/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Workspace API
 * Workspace builder APIs for FormOps
 * OpenAPI spec version: 1.0
 */

/**
 * Column value type.
 */
export type CreateDataLibraryCollectionFieldRequestValueType = typeof CreateDataLibraryCollectionFieldRequestValueType[keyof typeof CreateDataLibraryCollectionFieldRequestValueType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateDataLibraryCollectionFieldRequestValueType = {
  text: 'text',
  number: 'number',
  boolean: 'boolean',
  date: 'date',
} as const;
